import { TagNameT } from './entityApi';

export default class EntityError extends Error {
    constructor(public entityName: TagNameT, public type: 'legacy' | 'cache', public msg?: string) {
        super(`error [EntityError] for Entity ${entityName} in ${type} context. ${msg}`);
    }
}
